import utils from '@/common/util/utils'
import { get } from 'lodash'
import {
  PATH_NAME_ADULT_CHILDREN_SETTINGS,
  PATH_NAME_ADULT_SETTINGS,
  PATH_NAME_ADULTVERIFY,
  PATH_NAME_ADULTVERIFY_PIN_ADULT, PATH_NAME_ADULTVERIFY_PIN_ADULT_COMPLETE,
  PATH_NAME_ADULTVERIFY_PIN_CHILDREN,
  PATH_NAME_ADULTVERIFY_UNLOCK,
  PATH_NAME_ALARM_NOTICE_LIST, PATH_NAME_APOLLO_ADULTVERIFY_UNLOCK,
  PATH_NAME_HOME,
  PATH_NAME_LNB_EDIT_USER_ONE_OF_PROFILE,
  PATH_NAME_LNB_EDIT_USER_PROFILE,
  PATH_NAME_LNB_USER_INFO,
  PATH_NAME_LOGIN,
  PATH_NAME_LOGIN_APPLE_REDIRECT,
  PATH_NAME_MEMBER_LOGIN,
  PATH_NAME_T_LOGIN_CALLBACK
} from '@/common/router.const'

export default [
  // 로그인
  {
    path: '/login',
    name: PATH_NAME_LOGIN,
    props: true,
    components: {
      login: () => import(/* webpackChunkName: "login" */'@/views/login/Login')
    }
  },
  {
    path: '/member/member_login.html',
    name: PATH_NAME_MEMBER_LOGIN,
    components: {
      login: () => import(/* webpackChunkName: "member_login" */'@/views/login/member_login')
    }
  },
  {
    path: '/tlogincallback',
    name: PATH_NAME_T_LOGIN_CALLBACK,
    alias: '/tlogincallback.html',
    components: {
      callback: () => import('@/views/callback/TloginCallback')
    }
  },
  {
    path: '/member/login_apple',
    name: PATH_NAME_LOGIN_APPLE_REDIRECT,
    alias: '/member/login_apple.html',
    beforeEnter: (to, from, next) => {
      const fromPartnersPageKey = utils.cookies.getItem('need-pp-token') || null
      const token = get(to, 'query.id_token', '')
      if (fromPartnersPageKey !== null) {
        utils.cookies.removeItem('need-pp-token')
        location.replace('https://pp.wavve.com/?type=apple&id_token=' + token)
      } else {
        const referer = utils.cookies.getItem('referer-url') || '/'
        utils.cookies.removeItem('referer-url')
        next(`/member/login?type=apple&referer=${referer}&token=${token}`)
      }
    }
  },
  // 회원 정보
  {
    path: '/lnbUserInfo',
    name: PATH_NAME_LNB_USER_INFO,
    components: {
      lnbUserInfo: () => import('@/components/lnb/LnbUserInfo')
    }
  },
  {
    path: '/lnbEditUserProfile',
    name: PATH_NAME_LNB_EDIT_USER_PROFILE,
    components: {
      lnbEditUserProfile: () => import('@/components/lnb/LnbEditUserProfile')
    }
  },
  {
    path: '/lnbEditUserOneOfProfile/:profileNumber',
    name: PATH_NAME_LNB_EDIT_USER_ONE_OF_PROFILE,
    components: {
      lnbEditUserOneOfProfile: () => import('@/components/lnb/LnbEditUserOneOfProfile')
    }
  },
  {
    path: '/alarmNoticeList',
    name: PATH_NAME_ALARM_NOTICE_LIST,
    components: {
      alarmNoticeList: () => import('@/views/lnb/Alarms')
    }
  },
  {
    path: '/settings/adult',
    name: PATH_NAME_ADULT_SETTINGS,
    alias: '/settings/adult.html',
    components: {
      settings: () => import(/* webpackChunkName: "adult_settings" */ '@/views/settings/adult/AdultSettingsView')
    },
    beforeEnter: (to, from, next) => {
      const credential = utils.cookies.getCredential()
      if (credential === 'none' || credential === '') {
        next({ name: PATH_NAME_HOME })
      } else {
        next()
      }
    }
  },
  {
    path: '/settings/adult/protect',
    name: PATH_NAME_ADULT_CHILDREN_SETTINGS,
    alias: '/settings/adult/protect.html',
    components: {
      settings: () => import(/* webpackChunkName: "adult_settings_children" */ '@/views/settings/adult/AdultSettingsChildren.vue')
    }
  },
  // 성인인증
  {
    path: '/adultverify',
    name: PATH_NAME_ADULTVERIFY,
    components: {
      adultverify: () => import('@/views/adult/Adult')
    }
  },
  {
    path: '/adultverify/unlock',
    name: PATH_NAME_ADULTVERIFY_UNLOCK,
    components: {
      adultverify: () => import('@/views/adult/AdultContentUnLock')
    }
  },
  {
    path: '/apollo/adultverify/unlock',
    name: PATH_NAME_APOLLO_ADULTVERIFY_UNLOCK,
    components: {
      adultverify: () => import('@/views/adult/AdultContentUnLockForApollo')
    }
  },
  {
    path: '/adultverify/pin_children',
    name: PATH_NAME_ADULTVERIFY_PIN_CHILDREN,
    components: {
      adultverify: () => import('@/views/adult/AdultPinCheckForChildrenProtection.vue')
    },
    props: true
  },
  {
    path: '/adultverify/pin_adult',
    name: PATH_NAME_ADULTVERIFY_PIN_ADULT,
    components: {
      adultverify: () => import('@/views/adult/AdultPinCheckForSetPinCode.vue')
    },
    props: true
  },
  {
    path: '/adultverify/pin_adult/complete',
    name: PATH_NAME_ADULTVERIFY_PIN_ADULT_COMPLETE,
    components: {
      adultverify: () => import('@/views/adult/PinCodeComplete.vue')
    }
  },
  {
    path: '/external/verifiedAdult',
    name: PATH_NAME_ADULTVERIFY,
    components: {
      adultverify: () => import('@/views/adult/ExternalVerifiedAdultConfirm')
    }
  }
]
